export const PROMPT_WHITEBOARD_TEMPLATES_ONBOARDING_STATE_KEYS = {
	isFiveWhysDismissed: 'prompt-whiteboard-templates:isFiveWhysDismissed',
	isFourLsDismissed: 'prompt-whiteboard-templates:isFourLsDismissed',
	isRetroBlueprintDismissed: 'prompt-whiteboard-templates:isRetroBlueprintDismissed',
	isBrainwritingDismissed: 'prompt-whiteboard-templates:isBrainwritingDismissed',
	isDisruptiveBrainstormingDismissed:
		'prompt-whiteboard-templates:isDisruptiveBrainstormingDismissed',
} as const;

export const ExperimentPromptWhiteboardTemplatesOnboardingKeys = [
	...Object.values(PROMPT_WHITEBOARD_TEMPLATES_ONBOARDING_STATE_KEYS),
] as const;
